import { ArrowRight2 } from "iconsax-react";

interface ConfirmRow {
  key: string;
  label: string;
  outText?: string;
  inText?: string;
}

interface Props {
  sourceName: string;
  targetName: string;
  rows: ConfirmRow[];
  totalText: string;
  sourceChangeText: string;
  targetChangeText: string;
  sourceRemainingChangeText?: string;
  targetRemainingChangeText?: string;
  t: (key: string) => string;
}

export default function RedistributeConfirm({
  sourceName,
  targetName,
  rows,
  totalText,
  sourceChangeText,
  targetChangeText,
  sourceRemainingChangeText,
  targetRemainingChangeText,
  t,
}: Props) {
  return (
    <div className="flex flex-col gap-5">
      <div className="flex items-stretch gap-3">
        <div className="flex-1 p-3 radius-md surface-secondary-fill flex flex-col gap-1">
          <span className="text-body-regular-xs content-base-secondary">{t("redistribute.sourceLabel")}</span>
          <span className="text-body-bold-sm content-base-primary">{sourceName}</span>
          {sourceRemainingChangeText && (
            <span className="text-body-regular-xs content-base-primary mt-1">
              {t("redistribute.free")}: {sourceRemainingChangeText}
            </span>
          )}
          {sourceChangeText && (
            <span className="text-body-regular-xs content-base-secondary">
              {t("redistribute.currentBudget")}: {sourceChangeText}
            </span>
          )}
        </div>
        <div className="flex items-center content-base-secondary">
          <ArrowRight2 size={18} color="currentColor" />
        </div>
        <div className="flex-1 p-3 radius-md surface-secondary-fill flex flex-col gap-1">
          <span className="text-body-regular-xs content-base-secondary">{t("redistribute.targetLabel")}</span>
          <span className="text-body-bold-sm content-base-primary">{targetName}</span>
          {targetRemainingChangeText && (
            <span className="text-body-regular-xs content-base-primary mt-1">
              {t("redistribute.free")}: {targetRemainingChangeText}
            </span>
          )}
          {targetChangeText && (
            <span className="text-body-regular-xs content-base-secondary">
              {t("redistribute.currentBudget")}: {targetChangeText}
            </span>
          )}
        </div>
      </div>

      <div className="flex flex-col">
        {rows.map((row) => (
          <div key={row.key} className="flex items-center justify-between gap-3 py-2.5 border-b surface-base-stroke">
            <span className="text-body-regular-sm content-base-primary">{row.label}</span>
            <div className="flex flex-col items-end">
              {row.outText && <span className="text-body-regular-sm content-action-negative">{row.outText}</span>}
              {row.inText && <span className="text-body-regular-sm content-action-positive">{row.inText}</span>}
            </div>
          </div>
        ))}
      </div>

      <div className="flex items-center justify-between p-3 radius-md surface-secondary-fill">
        <span className="text-body-regular-sm content-base-secondary">{t("redistribute.totalToTransfer")}</span>
        <span className="text-body-bold-md content-action-info">{totalText}</span>
      </div>
    </div>
  );
}
